import { getThunkAndSlice } from "@src/store/getThunkAndSlice";

const initialState = false;

export interface IDeleteAdjustmentParams {
	AdjustmentIds: Array<number>;
}

export const { thunk: deleteAdjustment, slice: deleteAdjustmentSlice } = getThunkAndSlice<
	IDeleteAdjustmentParams,
	typeof initialState
>({
	initialState,
	path: "/api/Sales/DeleteAdjustment",
	method: "delete",
});
